// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qrcode[data-v-6b732dd0]{position:relative;left:50%;margin-left:-100px}", ""]);
// Exports
module.exports = exports;
